export default __webpack_public_path__ + "static/vu-e2cb34d980e762f2e064775f8e636402.png";